import React, { useRef, useState } from 'react'
import { Rating } from "react-simple-star-rating";
import './Student_Feedback.css'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Student_Feedback = () => {

    const data = [
        {
            review: "Attending the World Environment Day session changed the way I see nature. I now understand how even small actions like planting trees or reducing plastic can make a big difference. I feel inspired to start a green club in my school!",
            user: "Pratiksha Pethe",
            course: "BBA",
            date: "July 22-July 24",
            img: "/assets/images/home/student_feedback/img1.png"
        },
        {
            review: "Attending the World Environment Day session changed the way I see nature. I now understand how even small actions like planting trees or reducing plastic can make a big difference. I feel inspired to start a green club in my school!",
            user: "Sneha Kapoor",
            course: "MBA",
            date: "July 21-July 23",
            img: "/assets/images/home/student_feedback/img2.png"
        },
         {
            review: "Attending the World Environment Day session changed the way I see nature. I now understand how even small actions like planting trees or reducing plastic can make a big difference. I feel inspired to start a green club in my school!",
            user: "Smita Lad",
            course: "MBA",
            date: "July 22-July 24",
            img: "/assets/images/home/student_feedback/img2.png"
        },
    ]

     const swiperRef = useRef(null);

    const [rating, setRating] = useState(3);

    const [swiperInstance, setSwiperInstance] = useState(null);

    const handleMainSliderClick = (direction) => {
        if (!swiperInstance) {
            console.warn("Swiper instance not available yet!");
            return;
        }

        if (direction === "prev") {
            swiperInstance.slidePrev();
        } else if (direction === "next") {
            swiperInstance.slideNext();
        }
    };

    return (
        <section className='Student_Feedback'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-7'>
                        <div className='swiper_div'>
                            <Swiper
                                ref={swiperRef}
                                spaceBetween={15}
                                pagination={{
                                    dynamicBullets: true,
                                    clickable: true
                                }}
                                autoplay={{ delay: 300 }}
                                onSwiper={setSwiperInstance}
                                className="mySwiper"
                                breakpoints={{
                                    0: {
                                        slidesPerView: 1,

                                    },
                                    340: {
                                        slidesPerView: 1.2,
                                        spaceBetween: 5,
                                    },
                                    420: {
                                        slidesPerView: 1.4,
                                        spaceBetween: 5,
                                    },
                                    486: {
                                        slidesPerView: 2,
                                        spaceBetween: 5,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    992: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    1200: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    1400: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                }}
                            >

                                {data?.length > 0 && data?.map((item) => {
                                    return (
                                        <SwiperSlide >

                                            <div className='feedback_card'>
                                                <div className='rating_div'>
                                                    <Rating
                                                        initialValue={rating}
                                                        fillColor="#f4a51c"
                                                        className="react-simple-star-rating start"
                                                        SVGclassName="star-svg"
                                                        readonly={true} // This makes the rating display-only
                                                    />
                                                </div>

                                                <p className='review_text'>{item?.review}</p>

                                                <div className='footer_div'>
                                                    <div className='img_holder'>
                                                        <img src={process.env.PUBLIC_URL + item?.img} className='profile_img' />
                                                    </div>
                                                    <div className='text_holder'>
                                                        <p className='user'>{item?.user}</p>
                                                        <p className='course_text'>{item?.course} <span className='black_text'>({item?.date})</span></p>
                                                    </div>
                                                </div>

                                                <div className='quote_img_holder'>
                                                    <img src='/assets/images/home/student_feedback/quote.png' className='quote_img' />
                                                </div>

                                            </div>

                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>
                        </div>
                    </div>
                    <div className='col-lg-5'>
                        <div className='right_side'>
                            <p className='title_text'>Student Feedback</p>
                            <p className='descn_text'>
                                Your opinion matters, and by providing feedback, you
                                contribute to the continuous enhancement of our
                                academic programs, support services, and campus life
                            </p>

                            <div className="silder_btn">
                                <div
                                    className="back_btn"
                                    onClick={() => handleMainSliderClick("prev")}
                                >
                                    <FontAwesomeIcon icon={faAngleLeft} className='icon'/>
                                </div>
                                <div
                                    className="back_btn"
                                    onClick={() => handleMainSliderClick("next")}
                                >
                                    <FontAwesomeIcon icon={faAngleRight} className='icon'/>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Student_Feedback
